import { render } from "./LandingView.vue?vue&type=template&id=118da4f8&scoped=true"
import script from "./LandingView.vue?vue&type=script&lang=js"
export * from "./LandingView.vue?vue&type=script&lang=js"

import "./LandingView.vue?vue&type=style&index=0&id=118da4f8&scoped=true&lang=css"

import exportComponent from "/Users/nogglema/Documents/Ecampus/css-205-lab-2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118da4f8"]])

export default __exports__